<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_tab_item') }}</v-tab>
      <v-tab href="#tab-2"> {{ $t('quotation_item_tab_month_item') }}</v-tab>
      <v-tab href="#tab-3"> {{ $t('quotation_item_tab_pay_item') }}</v-tab>
      <v-tab href="#tab-4"> {{ $t('quotation_tab_second') }}</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="newInstallDataTableHeaders"
              :items="newItemList"
              :search="searchEditedNewInstall"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Index"
              :expanded.sync="expanded"
              :single-expand="singleExpand"
              disable-pagination
              hide-default-footer
            >
              <!-- <tr v-if="item.sort !== 'aa' && item.subIndex === -1"> -->
              <template v-slot:item="{ item, expand, isExpanded, index }">
                <tr>
                  <td class="text-start">
                    {{ item.Number }}
                  </td>
                  <td class="text-start">
                    {{ item.Describe }}
                  </td>
                  <td class="text-start">
                    {{ item.Name }}
                  </td>
                  <td class="text-end">
                    {{ item.Quantity }}
                  </td>
                  <td class="text-end">
                    {{ item.BuyQuantity }}
                  </td>
                  <td class="text-end">
                    {{ item.RentQuantity }}
                  </td>
                  <td class="text-start">
                    {{ item.Unit }}
                  </td>
                  <td class="text-end">
                    {{ item.TotalQuantity }}
                  </td>
                  <td class="text-end">
                    {{ item.Price }}
                  </td>
                  <td class="text-end">
                    {{ item.Discount }}
                  </td>
                  <td class="text-end">
                    {{ item.DiscountPrice }}
                  </td>
                  <td class="text-end">
                    {{ item.TotalPrice }}
                  </td>
                  <td class="text-end" v-if="item.Number || item.BomItems.length === 0">
                    {{ item.WarrantyPeriod }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-start">
                    {{ turnData(item.InstallPositions) }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="item.IsCustomerDevice">
                      mdi-check
                    </v-icon>
                    <v-icon v-else>
                      mdi-window-close
                    </v-icon>
                  </td>
                  <td class="text-end" v-if="item.Number || item.BomItems.length === 0">
                    {{ item.RepairPrice }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-end" v-if="item.Number || item.BomItems.length === 0">
                    {{ item.RepairWarrantyPeriod }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-start">
                    {{ item.Remark }}
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      class="mr-2"
                      @click="isShowEditNewInstallDialogBtn(item, index, -1)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="isShowDeleteNewInstallDialogBtn(item, index, -1)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td>
                    <v-icon
                      @click="upQuotationItem(item)"
                      v-if="index !== 0"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-arrow-up-drop-circle-outline
                    </v-icon>
                    <v-icon
                      @click="downQuotationItem(item)"
                      v-if="index !== newItemList.length - 1"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-arrow-down-drop-circle-outline
                    </v-icon>
                  </td>
                  <td v-if="item.Number || item.BomItems.length === 0"></td>
                  <td v-else class="text-start">
                    <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                      mdi-chevron-up
                    </v-icon>
                    <v-icon @click="expand(!isExpanded)" v-else>
                      mdi-chevron-down
                    </v-icon>
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="{ item, index }">
                <tr v-for="(field, idx) in item.BomItems" :key="field.Number">
                  <td class="text-start">
                    {{ field.Number }}
                  </td>
                  <td class="text-start">
                    {{ field.Describe }}
                  </td>
                  <td class="text-start">
                    {{ field.Name }}
                  </td>
                  <td class="text-end">
                    {{ field.Quantity }}
                  </td>
                  <td class="text-end">
                    {{ field.BuyQuantity }}
                  </td>
                  <td class="text-end">
                    {{ field.RentQuantity }}
                  </td>
                  <td class="text-start">
                    {{ field.Unit }}
                  </td>
                  <td class="text-end">
                    {{ field.TotalQuantity }}
                  </td>
                  <td class="text-end">
                    {{ field.Price }}
                  </td>
                  <td class="text-end">
                    {{ field.Discount }}
                  </td>
                  <td class="text-end">
                    {{ field.DiscountPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.TotalPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.WarrantyPeriod }}
                  </td>
                  <td class="text-start">
                    {{ turnData(field.InstallPositions) }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="field.IsCustomerDevice">
                      mdi-check
                    </v-icon>
                    <v-icon v-else>
                      mdi-window-close
                    </v-icon>
                  </td>

                  <td class="text-end">
                    {{ field.RepairPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.RepairWarrantyPeriod }}
                  </td>
                  <td class="text-start">
                    {{ field.Remark }}
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      class="mr-2"
                      @click="isShowEditNewInstallDialogBtn(field, index, idx)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="isShowDeleteNewInstallDialogBtn(field, index, idx)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('quotation_item_new_tool_bar_title') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchEditedNewInstall"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="isShowEditNewInstallDialog = true"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditNewInstallDialog"
                    v-if="isShowEditNewInstallDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ newInstallDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewInstall.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewInstall.CustomerDeviceType"
                                  :items="computedItemCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedNewInstall.IsCustomerDevice"
                                  ref="customerDeviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDevice"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-item-for-repair-price-combobox
                                  :fatherEditedItem="editedNewInstall"
                                  :editedItemIndex="editedNewInstallIndex"
                                  :itemName="'quotation_item_name'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedNewInstall.CustomerDeviceType"
                                  @setEditedItem="setEditedItem"
                                  v-if="editedNewInstallIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="quotationItemAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedNewInstall.Number"
                                  :label="$t('quotation_item_number')"
                                  disabled
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Unit"
                                    :disabled="
                                      editedNewInstall.Number !== '' &&
                                        editedNewInstall.Number !== null
                                    "
                                    @keyup.enter="focusNextInput"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Quantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                                lg="3"
                                xl="3"
                                v-if="editedNewInstall.Type !== 'Z100000000'"
                              >
                                <ValidationProvider
                                  :name="$t('quotation_item_buy_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_buy_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_rent_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.RentQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_rent_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalQuantity"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Price"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Discount"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.WarrantyPeriod"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewInstall.InstallPositions"
                                  :items="allInstallPositionsType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  small-chips
                                  multiple
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :loading="isLoading"
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.RepairPrice"
                                    :error-messages="errors[0]"
                                    :disabled="
                                      editedNewInstall.Number !== '' &&
                                        editedNewInstall.Number !== null &&
                                        repairCustomerId !== null &&
                                        repairCustomerId !== ''
                                    "
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.RepairWarrantyPeriod"
                                    :error-messages="errors[0]"
                                    :disabled="
                                      editedNewInstall.Number !== '' &&
                                        editedNewInstall.Number !== null &&
                                        repairCustomerId !== null &&
                                        repairCustomerId !== ''
                                    "
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewInstall.IsOptionalItem"
                                  label="選配"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedNewInstall.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedNewInstall">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedNewInstallBom">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteNewInstallDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeleteNewInstall"
                    @confirmDelete="confirmDeleteNewInstall"
                  />
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="isShowEditNewInstallBomDialog = true"
                  >
                    {{ $t('quotation_item_new_install_new_bom_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditNewInstallBomDialog"
                    v-if="isShowEditNewInstallBomDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ newInstallDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogBom">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewInstall.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewInstall.CustomerDeviceType"
                                  :items="computedBomCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedNewInstall.IsCustomerDevice"
                                  ref="bomCustomerDeviceTypeAutocomplete"
                                  @keyup.Enter="SetBomCustomerDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-bom-and-v-bom-for-repair-price-autocomplete
                                  :fatherEditedItem="editedNewInstall"
                                  :editedItemIndex="editedNewInstallIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedNewInstall.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedNewInstallIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Name"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedNewInstall.Describe"
                                  disabled
                                  label="描述"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Quantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_buy_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_buy_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_rent_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.RentQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_rent_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalQuantity"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Price"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.Discount"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewInstall.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewInstall.InstallPositions"
                                  :items="allInstallPositionsType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @change="setNewInstallPositionQuantity"
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewInstall.IsOptionalItem"
                                  label="選配"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedNewInstall.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedNewInstallBom">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedNewInstallBomBom">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteNewInstallBomDialog"
                    :deleteMessage="'quotation_item_delete_bom_dialog_title'"
                    @closeDelete="closeDeleteNewInstallBom"
                    @confirmDelete="confirmDeleteNewInstallBom"
                  />
                </v-toolbar>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <project-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          @setAllMonth="setAllMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMonthItem="setMonthItem"
          @deleteMonthItem="deleteMonthItem"
          @setMonthBomItemIndex="setMonthBomItemIndex"
          @setBomMonth="setBomMonth"
        />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="payItemDataTableHeaders"
              :items="payItemList"
              :search="searchPayItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Name"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('quotation_item_new_tool_bar_title') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchPayItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="openPayItem"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditPayItemDialog"
                    v-if="isShowEditPayItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_new_pay') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogPayItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <pay-item-autocomplete
                                  :fatherEditedItem="editedPayItem"
                                  :editedItemIndex="editedPayItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedPayItem="setEditedPayItem"
                                  v-if="editedPayItemIndex === -1"
                                  refName="itemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_car_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_car_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.TotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedPayItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedPayItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedPayItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeletePayItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeletePayItem"
                    @confirmDelete="confirmDeletePayItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditPayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeletePayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upPayItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downPayItem(item)"
                  v-if="index !== payItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-4">
        <project-discount-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :discountItemList="discountItemList"
          @setAllDiscount="setAllDiscount"
          @deleteDiscountItem="deleteDiscountItem"
          @setDiscountItem="setDiscountItem"
          @setDiscountItemIndex="setDiscountItemIndex"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { HttpQuotation, HttpBom, HttpInstallPosition } from '@/js/http-Manager'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import DeleteDialog from '@/components/DeleteDialog.vue'
import PayItemAutocomplete from '@/components/PayItemAutocomplete.vue'
import { PayType } from '@/js/PayType'
import QuotationItemForRepairPriceCombobox from '@/components/Quotation/ItemAutocomplete/QuotationItemForRepairPriceCombobox.vue'
import QuotationBomAndVBomForRepairPriceAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomAndVBomForRepairPriceAutocomplete.vue'
import ProjectMonthSetting from '@/components/Quotation/MonthItem/ProjectMonthSetting.vue'
import ProjectDiscountSetting from '@/components/Quotation/DiscountItem/ProjectDiscountSetting.vue'

extend('regex', regex)

export default {
  components: {
    DeleteDialog,
    PayItemAutocomplete,
    QuotationItemForRepairPriceCombobox,
    QuotationBomAndVBomForRepairPriceAutocomplete,
    ProjectMonthSetting,
    ProjectDiscountSetting
  },
  name: 'NewInstallCar',
  data: () => ({
    getIntersectingObj: null,
    isShowEditNewInstallDialog: false,
    isShowDeleteNewInstallDialog: false,
    editedNewInstallIndex: -1,
    searchEditedNewInstall: '',
    editedNewInstall: {
      Id: '',
      Number: '',
      Name: '',
      Quantity: 0,
      BuyQuantity: 0,
      RentQuantity: 0,
      Unit: '',
      TotalQuantity: 0,
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      RepairPrice: 0,
      TotalPrice: 0,
      RepairWarrantyPeriod: 0,
      WarrantyPeriod: 0,
      InstallPositions: [],
      CustomerDeviceType: 0,
      IsCustomerDevice: false,
      Remark: '',
      Describe: '',
      Custody: 0,
      IsOptionalItem: false,
      BomItems: []
    },
    defaultNewInstall: {
      Id: '',
      Number: '',
      Name: '',
      Quantity: 0,
      BuyQuantity: 0,
      RentQuantity: 0,
      Unit: '',
      TotalQuantity: 0,
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      RepairPrice: 0,
      TotalPrice: 0,
      RepairWarrantyPeriod: 0,
      WarrantyPeriod: 0,
      InstallPositions: [],
      CustomerDeviceType: 0,
      IsCustomerDevice: false,
      Remark: '',
      Describe: '',
      Custody: 0,
      IsOptionalItem: false,
      BomItems: []
    },

    isShowEditNewInstallBomDialog: false,
    isShowDeleteNewInstallBomDialog: false,
    editedNewInstallBomItemIndex: -1,
    expanded: [],
    singleExpand: true,
    allInstallPositionsType: [],
    isLoading: false,
    bomSource: null,
    computedTotalQuantity: 0,
    computedTotalPrice: 0,

    editedMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 0,
      Quantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      PayType: 1,
      TotalPrice: 0
    },
    defaultMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 0,
      Quantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      PayType: 1,
      TotalPrice: 0
    },
    editedMonthItemIndex: -1,
    editedMonthBomItemIndex: -1,
    isShowEditMonthItemDialog: false,
    searchMonthItem: '',
    isShowDeleteMonthItemDialog: false,
    searchPayItem: '',
    isShowEditPayItemDialog: false,
    editedPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    defaultPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    editedPayItemIndex: -1,
    isShowDeletePayItemDialog: false,
    customerDeviceTypeList: [],
    tempInstallPositions: [],

    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/
  }),
  async mounted () {
    await this.getAllInstallPositionsType()
    await this.getCustomerDeviceType()
  },
  computed: {
    newInstallDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: '描述', align: 'start', value: 'Describe' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        { text: this.$t('quotation_item_buy_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_rent_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_total_quantity'), align: 'end', value: 'TotalQuantity' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_warranty_period'), align: 'end', value: 'WarrantyPeriod' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPositions'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          justify: 'center',
          value: 'IsCustomerDevice',
          sortable: false
        },
        { text: this.$t('quotation_item_repair_price'), align: 'end', value: 'RepairPrice' },
        {
          text: this.$t('quotation_item_repair_warranty_period'),
          align: 'end',
          value: 'RepairWarrantyPeriod'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    newInstallDialogTitle () {
      return this.editedNewInstallIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    newItemList () {
      let array = []
      this.newInstallItemList.forEach((element, index) => {
        element.Index = index
        array.push(element)
      })
      return array
    },
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('month_quantity'), align: 'end', value: 'Quantity' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: '收費方式', align: 'start', value: 'PayType' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    payItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },

    computedItemCustomerDeviceTypeList () {
      let array = []
      if (this.editedNewInstall.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedNewInstall.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    computedBomCustomerDeviceTypeList () {
      let array = []
      let isRA400 =
        this.editedNewInstall.BomItems.findIndex((x) => x.Number.includes('RA400')) !== -1
      let hasSerialNumber =
        this.editedNewInstall.BomItems.findIndex((x) => x.HasSerialNumber) !== -1
      if (isRA400) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (hasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }
      return array
    }
  },
  watch: {
    carQuantity (val) {
      if (this.monthItemList.length > 0) {
        this.monthItemList.forEach((element) => {
          element.RentQuantity = val
          element.TotalPrice = val * element.DiscountPrice * element.Quantity
        })
      }
      if (this.payItemList.length > 0) {
        this.payItemList.forEach((element) => {
          element.BuyQuantity = val
          element.TotalPrice = val * element.DiscountPrice
        })
      }
      this.$emit('computedAmt')
    }
  },
  methods: {
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    setPayTypeAutocomplete (event) {
      this.$refs.payTypeAutocomplete.isMenuActive = false
      this.$refs.payTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setNewInstallPositionQuantity () {
      this.editedNewInstall.Quantity = this.editedNewInstall.InstallPositions.length
      this.editedNewInstall = JSON.parse(JSON.stringify(this.editedNewInstall))
      this.changeMoney()
    },

    SetBomCustomerDeviceType (event) {
      this.$refs.bomCustomerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.bomCustomerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBomName (event) {
      this.$refs.bomNameAutocomplete.isMenuActive = false
      this.$refs.bomNameAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setCustomerDevice (event) {
      this.$refs.customerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.customerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempInstallPositions = this.editedNewInstall.InstallPositions
    },
    setKeyUpAutocomplete (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedNewInstall.InstallPositions = this.tempInstallPositions
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    downPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllPay', temp)
    },
    upPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllPay', temp)
    },
    downMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllMonth', temp)
    },
    upMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllMonth', temp)
    },
    downQuotationItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setNewInstall', temp)
    },
    upQuotationItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setNewInstall', temp)
    },
    changeIsCustomerDevice () {
      if (this.editedNewInstall.IsCustomerDevice) {
        this.editedNewInstall.CustomerDeviceType = 3
      } else {
        this.editedNewInstall.CustomerDeviceType = 0
      }
      this.editedNewInstall = JSON.parse(JSON.stringify(this.editedNewInstall))
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    changeMonthTotal () {
      if (
        this.regexQuantity.test(this.editedMonthItem.RentQuantity) &&
        this.regexQuantity.test(this.editedMonthItem.Price) &&
        this.regexQuantity.test(this.editedMonthItem.Quantity) &&
        this.regexQuantity.test(this.editedMonthItem.Discount) &&
        this.regexQuantity.test(this.editedMonthItem.DiscountPrice)
      ) {
        this.editedMonthItem.DiscountPrice =
          this.editedMonthItem.Price - this.editedMonthItem.Discount
        this.editedMonthItem.TotalPrice =
          this.editedMonthItem.RentQuantity *
          this.editedMonthItem.DiscountPrice *
          this.editedMonthItem.Quantity *
          1
      }
    },
    changePayTotal () {
      if (
        this.regexPrice.test(this.editedPayItem.Price) &&
        this.regexQuantity.test(this.editedPayItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedPayItem.Discount) &&
        this.regexQuantity.test(this.editedPayItem.DiscountPrice)
      ) {
        this.editedPayItem.DiscountPrice = this.editedPayItem.Price - this.editedPayItem.Discount
        this.editedPayItem.TotalPrice =
          this.editedPayItem.BuyQuantity * this.editedPayItem.DiscountPrice * 1
      }
    },
    setEditedItem (val) {
      this.editedNewInstall.Id = val.Id
      this.editedNewInstall.Number = val.Number
      this.editedNewInstall.Name = val.Name
      this.editedNewInstall.Unit = val.Unit
      this.editedNewInstall.Price = val.Price
      this.editedNewInstall.IsMonthItem = val.IsMonthItem
      this.editedNewInstall.HasSerialNumber = val.HasSerialNumber
      this.editedNewInstall.IsDelete = val.IsDelete
      this.editedNewInstall.StoreNo = val.StoreNo
      this.editedNewInstall.RepairPrice = val.RepairPrice
      this.editedNewInstall.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedNewInstall.WarrantyPeriod = val.WarrantyPeriod
      this.editedNewInstall.Type = val.Type
      this.editedNewInstall = JSON.parse(JSON.stringify(this.editedNewInstall))
    },
    changeMoney () {
      if (
        this.regexPrice.test(this.editedNewInstall.Price) &&
        this.regexQuantity.test(this.editedNewInstall.BuyQuantity) &&
        this.regexQuantity.test(this.editedNewInstall.RentQuantity) &&
        this.regexQuantity.test(this.editedNewInstall.Quantity) &&
        this.regexPrice.test(this.editedNewInstall.Discount) &&
        this.regexPrice.test(this.editedNewInstall.DiscountPrice)
      ) {
        this.computedTotalQuantity =
          this.editedNewInstall.Quantity *
          (this.editedNewInstall.RentQuantity * 1 + this.editedNewInstall.BuyQuantity * 1)
        this.editedNewInstall.TotalQuantity = this.computedTotalQuantity
        this.editedNewInstall.DiscountPrice =
          this.editedNewInstall.Price - this.editedNewInstall.Discount
        this.computedTotalPrice =
          this.editedNewInstall.DiscountPrice *
          this.editedNewInstall.BuyQuantity *
          this.editedNewInstall.Quantity
        this.editedNewInstall.TotalPrice = this.computedTotalPrice
      }
    },
    setBomItem (val) {
      if (val) {
        this.editedNewInstall.Quantity = 0
        this.editedNewInstall.RentQuantity = 0
        this.editedNewInstall.BuyQuantity = 0
        this.editedNewInstall.TotalPrice = 0
        this.editedNewInstall.TotalQuantity = 0
        this.editedNewInstall.Id = val.Id
        this.editedNewInstall.Price = val.Price
        this.editedNewInstall.Name = val.Name
        this.editedNewInstall.Number = val.Number
        this.editedNewInstall.Unit = val.Unit
        this.editedNewInstall.Describe = val.Describe
        this.editedNewInstall.Remark = val.Remark
        this.editedNewInstall.BomItems = val.BomItems

        if (this.editedNewInstall.BomItems) {
          this.editedNewInstall.BomItems.forEach((element) => {
            element.IsCustomerDevice = val.IsCustomerDevice
            element.CustomerDeviceType = val.CustomerDeviceType
            element.Quantity = element.Quantity * 1
            element.RentQuantity = 0
            element.BuyQuantity = 0
            element.TotalPrice = 0
            element.TotalQuantity = 0
          })
        }
      } else {
        this.editedNewInstall.Quantity = 0
        this.editedNewInstall.RentQuantity = 0
        this.editedNewInstall.BuyQuantity = 0
        this.editedNewInstall.TotalPrice = 0
        this.editedNewInstall.TotalQuantity = 0
        this.editedNewInstall.Id = ''
        this.editedNewInstall.Price = 0
        this.editedNewInstall.Name = ''
        this.editedNewInstall.Number = ''
        this.editedNewInstall.Unit = ''
        this.editedNewInstall.Describe = ''
        this.editedNewInstall.Remark = ''
        this.editedNewInstall.BomItems = []
      }
    },
    turnData (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(
            ItemInstallPositionType.getFormInstallPositionTypeName(
              element,
              this.allInstallPositionsType
            )
          )
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getAllInstallPositionsType () {
      this.isLoading = true
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionsType = response && response.status === 200 ? response.data.Data : []
      this.isLoading = false
    },

    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditNewInstallDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number && item.BomItems.length > 0) {
        this.editedNewInstallIndex = mainIndex
        this.editedNewInstall = JSON.parse(JSON.stringify(item))
        this.changeMoney()
        this.isShowEditNewInstallBomDialog = true
      } else {
        this.editedNewInstallBomItemIndex = subIndex
        this.editedNewInstallIndex = mainIndex
        this.editedNewInstall = JSON.parse(JSON.stringify(item))
        this.changeMoney()
        this.isShowEditNewInstallDialog = true
      }
    },
    isShowDeleteNewInstallDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number && item.BomItems.length > 0) {
        this.editedNewInstallIndex = mainIndex
        this.editedNewInstall = JSON.parse(JSON.stringify(item))
        this.isShowDeleteNewInstallBomDialog = true
      } else {
        this.editedNewInstallBomItemIndex = subIndex
        this.editedNewInstallIndex = mainIndex
        this.editedNewInstall = JSON.parse(JSON.stringify(item))
        this.isShowDeleteNewInstallDialog = true
      }
    },
    closeEditedNewInstall () {
      this.isShowEditNewInstallDialog = false
      this.$nextTick(() => {
        this.editedNewInstall = JSON.parse(JSON.stringify(this.defaultNewInstall))
        this.editedNewInstallIndex = -1
        this.editedNewInstallBomItemIndex = -1
      })
    },
    confirmDeleteNewInstall () {
      if (this.editedNewInstall.subIndex !== -1) {
        this.$emit('setNewInstallDeleteBomItemIndex', this.editedNewInstallBomItemIndex)
      }
      this.$emit('setNewInstallDeleteIndex', this.editedNewInstallIndex)
      this.$emit('setDeleteNewInstall', this.editedNewInstall)
      this.closeDeleteNewInstall()
    },
    closeDeleteNewInstall () {
      this.isShowDeleteNewInstallDialog = false
      this.$nextTick(() => {
        this.editedNewInstall = JSON.parse(JSON.stringify(this.defaultNewInstall))
        this.editedNewInstallIndex = -1
        this.editedNewInstallBomItemIndex = -1
      })
    },
    async saveEditedNewInstallBom () {
      const isValid = await this.$refs.dialogItem.validate()
      if (isValid) {
        this.$emit('setNewInstallEditBomItemIndex', this.editedNewInstallBomItemIndex)
        this.$emit('setNewInstallIndex', this.editedNewInstallIndex)
        this.$emit('setEditNewInstall', this.editedNewInstall)
        this.closeEditedNewInstall()
      }
    },

    closeEditedNewInstallBom () {
      this.isShowEditNewInstallBomDialog = false
      this.$nextTick(() => {
        this.editedNewInstall = JSON.parse(JSON.stringify(this.defaultNewInstall))
        this.editedNewInstallIndex = -1
        this.editedNewInstallBomItemIndex = -1
      })
    },
    confirmDeleteNewInstallBom () {
      this.$emit('setNewInstallDeleteIndex', this.editedNewInstallIndex)
      this.$emit('setNewInstallDeleteBomItemIndex', this.editedNewInstallBomItemIndex)
      this.$emit('setDeleteNewInstall', this.editedNewInstall)
      this.closeDeleteNewInstallBom()
    },
    closeDeleteNewInstallBom () {
      this.isShowDeleteNewInstallBomDialog = false
      this.$nextTick(() => {
        this.editedNewInstall = JSON.parse(JSON.stringify(this.defaultNewInstall))
        this.editedNewInstallIndex = -1
        this.editedNewInstallBomItemIndex = -1
      })
    },
    async saveEditedNewInstallBomBom () {
      const isValid = await this.$refs.dialogBom.validate()

      if (isValid) {
        this.$emit('setNewInstallIndex', this.editedNewInstallIndex)
        this.$emit('setNewInstallEditBomItemIndex', this.editedNewInstallBomItemIndex)
        let response = await HttpBom.GetBomById({ bomId: this.editedNewInstall.Id })
        let errorMassage = ''
        if (response && response.status === 200) {
          let bom = response.status === 200 ? response.data.Data : {}
          if (bom) {
            this.editedNewInstall.BomItems.forEach((element, index) => {
              let bomItem = bom.BomItems.find((x) => x.Id === element.Id)
              if (bomItem) {
                element.Quantity = this.editedNewInstall.Quantity * bomItem.Quantity * 1
                element.BuyQuantity = this.editedNewInstall.BuyQuantity * 1
                element.RentQuantity = this.editedNewInstall.RentQuantity * 1
                element.TotalQuantity =
                  element.Quantity * (element.BuyQuantity + element.RentQuantity)
                element.InstallPositions = this.editedNewInstall.InstallPositions
                element.IsCustomerDevice = this.editedNewInstall.IsCustomerDevice
                element.CustomerDeviceType = this.editedNewInstall.CustomerDeviceType
                if (index === 0) {
                  element.Discount = this.editedNewInstall.Discount
                  element.DiscountPrice = element.Price - element.Discount
                  element.TotalPrice =
                    element.DiscountPrice * element.Quantity * element.BuyQuantity * 1
                } else {
                  element.Discount = 0
                  element.DiscountPrice = element.Price
                  element.TotalPrice = element.Price * element.Quantity * element.BuyQuantity * 1
                }
              } else {
                errorMassage += 'Bom表Item: 【' + element.Id + ' 】無此Item'
              }
            })
            this.$emit('setEditNewInstall', this.editedNewInstall)
            this.closeEditedNewInstallBom()
          } else {
            errorMassage = 'BOMId: 【' + this.editedNewInstall.Id + ' 】無此BOM'
          }
        } else {
          errorMassage = '取得BOM失敗'
        }
        if (errorMassage) {
          alert(errorMassage)
        }
      }
    },

    setEditedPayItem (val) {
      this.editedPayItem.Id = val.Id
      this.editedPayItem.Number = val.Number
      this.editedPayItem.Name = val.Name
      this.editedPayItem.Unit = val.Unit
      this.editedPayItem.Price = val.Price
      this.editedPayItem.IsDelete = val.IsDelete
      this.editedPayItem.StoreNo = val.StoreNo
      this.changePayTotal()
      this.editedPayItem = JSON.parse(JSON.stringify(this.editedPayItem))
    },
    closeEditedPayItem () {
      this.isShowEditPayItemDialog = false
      this.editedPayItem = JSON.parse(JSON.stringify(this.defaultPayItem))
      this.editedPayItemIndex = -1
    },
    openPayItem () {
      this.editedPayItem.BuyQuantity = this.carQuantity
      this.isShowEditPayItemDialog = true
    },
    isShowEditPayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.editedPayItem = JSON.parse(JSON.stringify(item))
      this.isShowEditPayItemDialog = true
    },
    async saveEditedPayItem () {
      const isValid = await this.$refs.dialogPayItem.validate()
      if (isValid) {
        this.$emit('setPayItemIndex', this.editedPayItemIndex)
        this.$emit('setPayItem', this.editedPayItem)
        this.closeEditedPayItem()
      }
    },
    isShowDeletePayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.isShowDeletePayItemDialog = true
    },
    closeDeletePayItem () {
      this.editedPayItemIndex = -1
      this.isShowDeletePayItemDialog = false
    },
    confirmDeletePayItem () {
      this.$emit('deletePayItem', this.editedPayItemIndex)
      this.closeDeletePayItem()
    },

    setDiscountItemIndex (index) {
      this.$emit('setDiscountItemIndex', index)
    },
    setDiscountItem (val) {
      this.$emit('setDiscountItem', val)
    },
    deleteDiscountItem (index) {
      this.$emit('deleteDiscountItem', index)
    },
    setAllDiscount (temp) {
      this.$emit('setAllDiscount', temp)
    },

    setAllMonth (temp) {
      this.$emit('setAllMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMonthItem (val) {
      this.$emit('setMonthItem', val)
    },
    deleteMonthItem () {
      this.$emit('deleteMonthItem')
    },
    setMonthBomItemIndex (bomIndex) {
      this.$emit('setMonthBomItemIndex', bomIndex)
    },
    setBomMonth () {
      this.$emit('setBomMonth')
    }
  },
  props: [
    'newInstallItemList',
    'isAllTextFieldDisabled',
    'repairCustomerId',
    'monthItemList',
    'payItemList',
    'carQuantity',
    'discountItemList',
    'allPayType',
    'allPayQuantityType'
  ]
}
</script>
